<div class="dialog-container">
  <div class="dialog-header flex_sb" style="border-bottom: 1px solid #e4e4e4">
    <div class="dialog-header-title">
      <ng-container *ngIf="data.type !== 'cashier-report'">
        {{
          data.type == 'close-cashier'
            ? ('OPEN_CASH_DRAWER.CLOSE_CASHIER' | fallbackTranslate)
            : ('OPEN_CASH_DRAWER.OPEN_CASHIER' | fallbackTranslate)
        }}
        <div class="fs-16 fw-400 clr-333 txt-none" *ngIf="billingCounterName" [innerHTML]="billingCounterInfo"></div>
      </ng-container>
      <ng-container *ngIf="data.type === 'cashier-report'">
        {{ 'OPEN_CASH_DRAWER.CASHIER_REPORT' | fallbackTranslate }}
        <div class="fs-16 fw-400 clr-33 txt-none" *ngIf="billingCounterName" [innerHTML]="billingCounterInfo"></div>
      </ng-container>
    </div>
    <div class="dialog-header-cross flex-center" (click)="cancel_clicked()">
      <img [src]="images.CROSS" class="img-20" alt="close"/>
    </div>
  </div>
  <div class="dialog-form">
    <div class="sub-header" *ngIf="data.type === 'cashier-report'">
      <p>
        <strong>{{ 'OPEN_CASH_DRAWER.NOTE' | fallbackTranslate | uppercase }}:</strong>
        {{ 'OPEN_CASH_DRAWER.CASHIER_REPORT_WILL_BE_UPDATED_IN_EOD_REPORT' | fallbackTranslate }}
      </p>
    </div>
    <div class="form-container" style="padding: 30px 22px">
      <ng-container *ngIf="data.type !== 'cashier-report'">
        <ng-container *ngIf="data.type === 'close-cashier'">
          <div class="flex align_center m-b-10 close-cashier-confirmation">
            <div class="m-r-20">
              <i
                nz-icon
                nzType="exclamation-circle"
                style="font-size: 25px"
              ></i>
            </div>
            <p>
              {{ 'OPEN_CASH_DRAWER.PLEASE_CONFIRM_WITH_MANAGER' | fallbackTranslate }}
            </p>
          </div>
          <p>
            <Strong>
              {{
                'OPEN_CASH_DRAWER.COUNT_THE_AMOUNT_OF_CASH_LEFT_IN_DRAWER_AT_THE_END_OF_DAY'
                  | fallbackTranslate
              }}
            </Strong>
          </p>
          <p>
            <Strong>{{ 'OPEN_CASH_DRAWER.NOTE' | fallbackTranslate }}:</Strong>
            {{ 'OPEN_CASH_DRAWER.THIS_ACTION_WILL_END_TODAY' | fallbackTranslate }}
          </p>
          <p>
            {{ 'OPEN_CASH_DRAWER.PLEASE_ENSURE_THAT_YOU_TAKE' | fallbackTranslate }}
          </p>
          <p>
            <Strong>
              {{
                'OPEN_CASH_DRAWER.ARE_YOU_SURE_YOU_WANT_TO_CONTINUE' | fallbackTranslate
              }}
            </Strong>
          </p>
        </ng-container>
        <ng-container *ngIf="data.type === 'open-cashier'">
          <p>
            <Strong>
              {{
                'OPEN_CASH_DRAWER.COUNT_THE_AMOUNT_OF_CASH_AT_THE_BEGINNING_OF_YOUR_DAY'
                  | fallbackTranslate
              }}
            </Strong>
          </p>
          <p>
            <Strong>{{ 'OPEN_CASH_DRAWER.NOTE' | fallbackTranslate }}:</Strong>
            {{
              'OPEN_CASH_DRAWER.THIS_ACTION_WILL_START_TODAY_CASH_COUNTING'
                | fallbackTranslate
            }}
          </p>
          <p>
            <Strong>
              {{
                'OPEN_CASH_DRAWER.ARE_YOU_SURE_YOU_WANT_TO_CONTINUE' | fallbackTranslate
              }}
            </Strong>
          </p>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="data.type === 'cashier-report'">
        <div class="cashier-report-wrapper">
          <table>
            <ng-container *ngIf="isForceCloseCashierEnabled(); else closeCashier">
              <tr>
                <td>{{ 'OPEN_CASH_DRAWER.OPENING_SHIFT' | fallbackTranslate | uppercase}}</td>
                <td>
                  <strong>{{ cashier_report?.open_cashier_date_time }}</strong>
                </td>
              </tr>

              <tr>
                <td>{{ 'OPEN_CASH_DRAWER.CLOSING_SHIFT' | fallbackTranslate | uppercase}}</td>
                <td>
                  <strong>{{ cashier_report?.close_cashier_date_time }}</strong>
                </td>
              </tr>
            </ng-container>
            <ng-template #closeCashier>
              <tr *ngIf="isHq && cashier_report?.restaurant_name">
                <td>{{ 'OPEN_CASH_DRAWER.OUTLET_NAME' | fallbackTranslate | uppercase}}</td>
                <td>
                  <strong>{{ cashier_report?.restaurant_name }}</strong>
                </td>
              </tr>

              <tr>
                <td>{{ 'DATE' | fallbackTranslate | uppercase}}</td>
                <td>
                  <strong>{{ cashier_report?.date }}</strong>
                </td>
              </tr>

              <tr *ngIf="isHq && cashier_report?.open_cashier_date_time">
                <td>{{ 'OPEN_CASH_DRAWER.OPENING_SHIFT' | fallbackTranslate | uppercase}}</td>
                <td>
                  <strong>{{ cashier_report?.open_cashier_date_time }}</strong>
                </td>
              </tr>

              <tr *ngIf="isHq && cashier_report?.close_cashier_date_time">
                <td>{{ 'OPEN_CASH_DRAWER.CLOSING_SHIFT' | fallbackTranslate | uppercase}}</td>
                <td>
                  <strong>{{ cashier_report?.close_cashier_date_time }}</strong>
                </td>
              </tr>

              <tr *ngIf="!isHq">
                <td>{{ 'TIME' | fallbackTranslate | uppercase}}</td>
                <td>
                  <strong>{{ cashier_report?.time }}</strong>
                </td>
              </tr>
            </ng-template>

            <tr>
              <td>{{ 'OPEN_CASH_DRAWER.STAFF' | fallbackTranslate | uppercase}}</td>
              <td>
                <strong>{{ cashier_report?.staff_name }}</strong>
              </td>
            </tr>

            <tr *ngIf="!isHq || cashier_report?.counter_name">
              <td>{{ 'OPEN_CASH_DRAWER.BILLING_COUNTER' | fallbackTranslate | uppercase}}</td>
              <td>
                <strong>{{ cashier_report?.counter_name }}</strong>
              </td>
            </tr>

            <tr>
              <td>{{ 'OPEN_CASH_DRAWER.OPENING_CASH_FLOAT' | fallbackTranslate | uppercase}}</td>
              <td>
                <strong>{{ cashier_report?.opening_cash_float }}</strong>
              </td>
            </tr>

            <tr>
              <td>{{ 'OPEN_CASH_DRAWER.TOTAL_CASH_IN' | fallbackTranslate | uppercase}}</td>
              <td>
                <strong>{{ cashier_report?.total_cash_in }}</strong>
              </td>
            </tr>

            <tr>
              <td>{{ 'OPEN_CASH_DRAWER.CASH_IN_SALES' | fallbackTranslate | uppercase}}</td>
              <td>
                <strong>{{ cashier_report?.cash_in_sales }}</strong>
              </td>
            </tr>

            <tr>
              <td>{{ 'OPEN_CASH_DRAWER.CASH_IN_OTHERS' | fallbackTranslate | uppercase}}</td>
              <td>
                <strong>{{ cashier_report?.cash_in_others }}</strong>
              </td>
            </tr>

            <tr>
              <td>{{ 'OPEN_CASH_DRAWER.TOTAL_CASH_OUT' | fallbackTranslate | uppercase}}</td>
              <td>
                <strong>{{ cashier_report?.total_cash_out }}</strong>
              </td>
            </tr>

            <tr>
              <td>{{ 'OPEN_CASH_DRAWER.NET_CASH_BALANCE' | fallbackTranslate | uppercase}}</td>
              <td>
                <strong>{{ cashier_report?.net_cash_balance }}</strong>
              </td>
            </tr>

            <tr>
              <td>
                {{ 'OPEN_CASH_DRAWER.EXPECTED_CASH_IN_DRAWER' | fallbackTranslate | uppercase}}
              </td>
              <td>
                <strong
                  >{{ Currency }}
                  {{ cashier_report?.expected_cash_in_drawer }}</strong
                >
              </td>
            </tr>

            <ng-container *ngIf="data?.cashTally">
              <tr>
                <td>
                  {{ 'OPEN_CASH_DRAWER.ACTUAL_CASH_IN_DRAWER' | fallbackTranslate | uppercase}}
                </td>
                <td>
                  <strong
                    >{{ Currency }}
                    {{ cashier_report?.actual_cash_in_drawer || 0 }}</strong
                  >
                </td>
              </tr>

              <tr>
                <td>{{ 'OPEN_CASH_DRAWER.EXCESS_SHORT_CASH' | fallbackTranslate | uppercase}}</td>
                <td>
                  <strong
                    >{{ Currency }}
                    {{ cashier_report?.excess_short_cash || 0 }}</strong
                  >
                </td>
              </tr>

              <tr>
                <td>{{ 'OPEN_CASH_DRAWER.CLOSE_CASHIER' | fallbackTranslate | uppercase}}</td>
                <td>
                  <strong
                    >
                    {{ cashier_report?.close_cashier || '-' }}</strong
                  >
                </td>
              </tr>
            </ng-container>
          </table>

          <table *ngIf="cashier_report?.cash_count_enabled">
            <tr>
              <th colspan="2">{{ 'OPEN_CASH_DRAWER.CASH_COUNTING' | fallbackTranslate }}</th>
            </tr>
            <ng-container *ngFor="let item of cashier_report?.denominations_arr">
              <tr>
                <td class="wd-50">{{ Currency }} {{ item?.value }}</td>
                <td class="wd-50">
                  <strong>{{ item?.count }}</strong>
                </td>
              </tr>
            </ng-container>
          </table>
        </div>
      </ng-container>
    </div>

    <div class="footer">
      <div class="flex_sb">
        <ng-container *ngIf="data.type !== 'cashier-report'">
          <button class="go_back" (click)="cancel_clicked()">
            {{ 'OPEN_CASH_DRAWER.GO_BACK' | fallbackTranslate }}
          </button>
          <button class="save" (click)="continue_clicked()">
            {{ 'OPEN_CASH_DRAWER.CONTINUE' | fallbackTranslate | uppercase }}
          </button>
        </ng-container>
      </div>
      <ng-container *ngIf="data.type === 'cashier-report'">
        <div nz-row nzJustify="space-around" nzAlign="middle" [nzGutter]="16">
          <div *ngIf="!isHq" nz-col [nzSpan]="!data?.cashierData ? 12: 6">
            <button class="save primary-button" (click)="print_clicked()">
              {{ 'OPEN_CASH_DRAWER.PRINT' | fallbackTranslate }}
            </button>
          </div>
          <div nz-col [nzSpan]="!isHq ? 6: 12"  *ngIf="data?.cashierData">
            <button class="save primary-button" (click)="downloadCashierReport()">
              {{ 'OPEN_CASH_DRAWER.DOWNLOAD' | fallbackTranslate }}
            </button>
          </div>
          <div nz-col nzSpan="12">
            <button class="save" (click)="done_clicked()">
              {{ 'OPEN_CASH_DRAWER.DONE' | fallbackTranslate }}
            </button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
